import { render, staticRenderFns } from "./embedded-video-player.vue?vue&type=template&id=795da421&scoped=true"
import script from "./embedded-video-player.vue?vue&type=script&lang=js"
export * from "./embedded-video-player.vue?vue&type=script&lang=js"
import style0 from "./embedded-video-player.vue?vue&type=style&index=0&id=795da421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795da421",
  null
  
)

export default component.exports